import React from 'react';
import Icon from '../../../components/AppIcon';
import { useGlobalContext } from '../../../context/GlobalContext';

const ContactMethods = () => {
  const { globalSettings } = useGlobalContext();

  const contactMethods = [
    {
      type: 'email',
      label: 'Email',
      value: globalSettings?.contact_email || 'sudhan.r.web@gmail.com',
      href: `mailto:${globalSettings?.contact_email || 'sudhan.r.web@gmail.com'}`,
      icon: 'Mail',
      description: 'Best for detailed project discussions',
      responseTime: 'Within 24 hours'
    },
    {
      type: 'whatsapp',
      label: 'WhatsApp',
      value: globalSettings?.contact_phone || '+91 9940980978',
      href: `https://wa.me/${(globalSettings?.contact_phone || '919940980978').replace(/[-+ \(\)]/g, '')}`,
      icon: 'MessageCircle',
      description: 'Quick messaging for updates or inquiries',
      responseTime: 'Replies within a few hours'
    },
    {
      type: 'linkedin',
      label: 'LinkedIn',
      value: (globalSettings?.social_linkedin && globalSettings.social_linkedin.includes('/in/')) ? globalSettings.social_linkedin.split('/in/')[1]?.replace(/\/$/, '') : 'sudhan23082004',
      href: globalSettings?.social_linkedin || 'https://www.linkedin.com/in/sudhan23082004/',
      icon: 'Linkedin',
      description: 'Professional networking and referrals',
      responseTime: 'Within 48 hours'
    },
    {
      type: 'calendar',
      label: 'Schedule Call',
      value: 'Book a consultation',
      href: globalSettings?.calendly_url || 'https://calendly.com/sudhan-r-web/30min',
      icon: 'Calendar',
      description: '30-minute discovery call',
      responseTime: 'Available slots updated daily'
    }
  ];

  const handleContactClick = (method) => {
    if (method.type === 'calendar') {
      window.open(method.href, '_blank', 'noopener,noreferrer');
      return;
    }

    if (method.href.startsWith('http')) {
      window.open(method.href, '_blank', 'noopener,noreferrer');
    } else {
      window.location.href = method.href;
    }
  };


  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <h2 className="font-heading font-semibold text-2xl text-text-primary mb-2">
          Choose Your Preferred Contact Method
        </h2>
        <p className="text-text-secondary">
          I'm here to help and respond promptly through multiple channels.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {contactMethods.map((method) => (
          <div
            key={method.type}
            className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-xl p-6 hover:shadow-accent/5 transition-smooth cursor-pointer group focus:outline-none focus:ring-2 focus:ring-accent"
            onClick={() => handleContactClick(method)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleContactClick(method);
              }
            }}
            aria-label={`Connect via ${method.label}: ${method.value}`}
            title={`Connect via ${method.label}`}
          >
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center group-hover:bg-accent/20 transition-smooth">
                <Icon 
                  name={method.icon} 
                  size={24} 
                  color="var(--color-accent)" 
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading font-semibold text-lg text-text-primary mb-1">
                  {method.label}
                </h3>
                <p className="text-accent font-medium mb-2 break-all">
                  {method.value}
                </p>
                <p className="text-text-secondary text-sm mb-2">
                  {method.description}
                </p>
                <div className="flex items-center text-xs text-text-muted">
                  <Icon name="Clock" size={14} className="mr-1" />
                  {method.responseTime}
                </div>
              </div>
              <Icon 
                name="ExternalLink" 
                size={16} 
                className="text-text-muted group-hover:text-accent transition-smooth" 
              />
            </div>
          </div>
        ))}
      </div>

      <div className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-xl p-6 mt-8">
        <div className="flex items-start space-x-4">
          <div className="w-10 h-10 bg-warning/10 rounded-lg flex items-center justify-center">
            <Icon name="MapPin" size={20} className="text-warning-light" />
          </div>
          <div>
            <h3 className="font-heading font-semibold text-lg text-text-primary mb-2">
              Location & Availability
            </h3>
            <div className="space-y-2 text-text-secondary">
              {globalSettings?.contact_location ? (
                <a href={globalSettings.contact_location} target="_blank" rel="noopener noreferrer" className="flex items-center hover:text-accent transition-colors">
                  <Icon name="Globe" size={16} className="mr-2" />
                  Based in Ranipet, Tamil Nadu, India (IST timezone)
                </a>
              ) : (
                <p className="flex items-center">
                  <Icon name="Globe" size={16} className="mr-2" />
                  Based in Ranipet, Tamil Nadu, India (IST timezone)
                </p>
              )}
              <p className="flex items-center">
                <Icon name="Wifi" size={16} className="mr-2" />
                Available for remote work worldwide
              </p>
              <p className="flex items-center">
                <Icon name="Users" size={16} className="mr-2" />
                Open to in-person sessions in Tamil Nadu & online globally
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center pt-6">
        <div className="inline-flex items-center space-x-2 text-sm text-text-muted bg-white/5 border border-white/10 px-4 py-2 rounded-lg">
          <Icon name="Shield" size={16} />
          <span>All communications are confidential and secure</span>
        </div>
      </div>
    </div>
  );
};

export default ContactMethods;